[
    {
        "field": "ng_tas_authorization_detail",
        "header": ""
    },
    {
        "field": "tas_authorization_detail_id",
        "header": ""
    },
    {
        "field": "ppl_auth_number",
        "header": ""
    },
    {
        "field": "client_auth_number",
        "header": ""
    },
    {
        "field": "servicecode_detail_id",
        "header": "Service Code"
    },
    {
        "field": "modifier_detail_id_1",
        "header": ""
    },
    {
        "field": "modifier_detail_id_2",
        "header": ""
    },
    {
        "field": "modifier_detail_id_3",
        "header": ""
    },
    {
        "field": "modifier_detail_id_4",
        "header": ""
    },
    {
        "field": "source_org_id",
        "header": "Regional Center"
    },
    {
        "field": "source_type_lkp",
        "header": "Auth Source"
    },
    {
        "field": "participant_id",
        "header": ""
    },
    {
        "field": "provider_id",
        "header": ""
    },
    {
        "field": "auth_unit",
        "header": "Authorized Dollars"
    },
    {
        "field": "auth_dollar",
        "header": ""
    },
    {
        "field": "billable_rate",
        "header": ""
    },
    {
        "field": "from_date",
        "header": "Auth Start Date"
    },
    {
        "field": "to_date",
        "header": "Auth End Date"
    },
    {
        "field": "start_date",
        "header": "Auth Start Date"
    },
    {
        "field": "end_date",
        "header": "Auth End Date"
    },
    {
        "field": "primary_diagnosis_id",
        "header": ""
    },
    {
        "field": "hios_id_lkp",
        "header": ""
    },
    {
        "field": "plan_id_lkp",
        "header": ""
    },
    {
        "field": "service_admin_lkp",
        "header": ""
    },
    {
        "field": "unittype_lkp",
        "header": ""
    },
    {
        "field": "status_lkp",
        "header": "Auth Status"
    },
    {
        "field": "source_detail",
        "header": "Source Detail"
    },
    {
        "field": "decision_comments",
        "header": "Decision Comments"
    },
    {
        "field": "decision_by",
        "header": "Decision By"
    },
    {
        "field": "auth_frequency_lkp",
        "header": ""
    },
    {
        "field": "sun_hrs",
        "header": "Sun Hours"
    },
    {
        "field": "mon_hrs",
        "header": "Mon Hours"
    },
    {
        "field": "tues_hrs",
        "header": "Tue Hours"
    },
    {
        "field": "wed_hrs",
        "header": "Wed Hours"
    },
    {
        "field": "thu_hrs",
        "header": "Thu Hours"
    },
    {
        "field": "fri_hrs",
        "header": "Fri Hours"
    },
    {
        "field": "sat_hrs",
        "header": "Sat Hours"
    },
    {
        "field": "primary_diagnosis_id_1",
        "header": ""
    },
    {
        "field": "primary_diagnosis_id_2",
        "header": ""
    },
    {
        "field": "primary_diagnosis_id_3",
        "header": ""
    },
    {
        "field": "hha_id",
        "header": ""
    },
    {
        "field": "hha_auth_id",
        "header": ""
    },
    {
        "field": "consumer_plan_id",
        "header": ""
    },
    {
        "field": "is_deleted",
        "header": ""
    },
    {
        "field": "comments",
        "header": "Comments"
    },
    {
        "field": "medicaid_id",
        "header": "UCI ID"
    },
    {
        "field": "payer_id",
        "header": ""
    },
    {
        "field": "batch_file_details_id",
        "header": ""
    },
    {
        "field": "plan_servicecode",
        "header": "Service Description"
    },
    {
        "field": "total_auth_units",
        "header": ""
    },
    {
        "field": "estmtd_first_week_unit",
        "header": ""
    },
    {
        "field": "estmtd_mid_week_unit",
        "header": ""
    },
    {
        "field": "estmtd_last_week_unit",
        "header": ""
    },
    {
        "field": "service_coordinator",
        "header": "Service Cordinator"
    },
    {
        "field": "monthly_fms_fee",
        "header": ""
    }
]